import type { WorksheetAssignee } from '@mathflat/domain/Worksheet'
import { generatePath } from 'react-router'

import {
  QR_SCORING_ENTRY_QUERY,
  SCORING_TARGET_QUERY_PARAM,
} from '@/page/Lesson/Worksheet/WorksheetPerson/_utils/scoringDeepLink'
import { RouteName } from '@/router/RouteName'

export const buildStudentScoringPath = (assignee: WorksheetAssignee) =>
  `${generatePath(RouteName.lessonWorksheetStudent, { studentId: assignee.studentId })}?${SCORING_TARGET_QUERY_PARAM}=${assignee.studentWorksheetId}&${QR_SCORING_ENTRY_QUERY}`
